export const iconFontAwesomeLogisticsSquareNfi = (
	<i className="fa-solid fa-square-nfi"></i>
);
